module.exports = __webpack_public_path__ + "media/img/paygold/step3-23bbcd1e114915ce8c6f6cdda72696d4.png";